export default __webpack_public_path__ + "static/media/hobbyhorse.4d7b52ec.png";